import { motion } from "framer-motion";
import { Image as ImageIcon } from "lucide-react";
import SectionLabel from "./SectionLabel";

// 10 thumbnail slots. Replace `src` as thumbnails are uploaded.
const thumbnails = [
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/jzmfe163_uBTEhbxSlTs-HD.jpg", alt: "Thumbnail 1" },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/rwlciu73_HIkv9_k3xkY-HD.jpg", alt: "Thumbnail 2" },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/u116ayff_d6GW62sTHLk-HD.jpg", alt: "Thumbnail 3" },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/0bbh1b74_B-z_CpZwDcY-HD.jpg", alt: "Thumbnail 4" },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/y4hub23s__rezFBrHHDo-HD.jpg", alt: "Thumbnail 5" },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/1xavwbdw_XuiNawFjQJY-HD.jpg", alt: "Thumbnail 6" },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/z8m7172p_oYK2q6IBkIs-HD.jpg", alt: "Thumbnail 7" },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/0bkvwi5p_mdezBykPed0-HD.jpg", alt: "Thumbnail 8" },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/lgtn1iyq_dvNdpjsi8_0-HD.jpg", alt: "Thumbnail 9" },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/t1wmls6w_5h8zCVbBk-I-HD.jpg", alt: "Thumbnail 10" },
];

export default function ThumbnailGallery() {
  return (
    <section
      id="thumbnails"
      data-testid="thumbnail-gallery-section"
      className="relative px-6 md:px-16 lg:px-32 py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-16">
        <div>
          <SectionLabel number="03" label="Thumbnail Gallery" testId="thumbnails-label" />
          <h2 className="font-display font-bold uppercase text-2xl md:text-4xl tracking-tighter leading-[0.95] [word-spacing:0.18em] max-w-3xl">
            Thumbnails that <span className="text-[#F4C75E]">earn the click.</span>
          </h2>
        </div>
        <p className="text-sm md:text-base text-[#A3A3A3] max-w-sm">
          Bold, considered thumbnail design, engineered for stronger CTR the moment
          your episode drops.
        </p>
      </div>

      {/* 3-column layout for larger thumbnails; last item centered */}
      <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-3 gap-5 md:gap-7">
        {thumbnails.map((t, i) => {
          // Center the last thumbnail (position 10) on the final row of the 3-col grid
          const isLast = i === thumbnails.length - 1;
          return (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.05 }}
              data-testid={`thumbnail-${i}`}
              className={`group relative overflow-hidden rounded-2xl bg-[#0A0A0A] border border-[#222] hover:border-[#F4C75E] transition-colors duration-500 aspect-video cursor-pointer ${
                isLast ? "md:col-start-2" : ""
              }`}
            >
              {t.src ? (
                <img
                  src={t.src}
                  alt={t.alt}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500"
                />
              ) : (
                <div
                  className="absolute inset-0 flex flex-col items-center justify-center gap-2 text-[#666]"
                  style={{
                    backgroundImage:
                      "repeating-linear-gradient(45deg, rgba(244,199,94,0.05) 0px, rgba(244,199,94,0.05) 1px, transparent 1px, transparent 14px)",
                  }}
                >
                  <div className="w-10 h-10 rounded-full border border-[#333] flex items-center justify-center">
                    <ImageIcon className="w-4 h-4" />
                  </div>
                  <div className="text-[10px] uppercase tracking-[0.3em]">
                    Thumbnail {String(i + 1).padStart(2, "0")}
                  </div>
                </div>
              )}
            </motion.figure>
          );
        })}
      </div>
    </section>
  );
}
